import * as React from 'react'
import Box from '@mui/material/Box'
import Radio from '@mui/material/Radio'
import { useFormikContext } from 'formik'
import Typography from '@mui/material/Typography'
import RadioGroup from '@mui/material/RadioGroup'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'

import { ImportUtilityModel } from '../../typings'
import { ImportEntityType } from '../../../typings'

const importTypes = [
  {
    label: 'Pending Leads',
    value: ImportEntityType.DraftLead,
    disabled: false,
  },
  { label: 'Leads', value: ImportEntityType.Lead, disabled: false },
  {
    label: 'Opportunities',
    value: ImportEntityType.Opportunity,
    disabled: false,
  },
]

export function ImportTypeSelect() {
  const {
    values: { entityType },
    setValues,
  } = useFormikContext<ImportUtilityModel>()

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = parseInt(event.target.value) as ImportEntityType

    setValues((model) => ({
      ...model,
      entityType: value,
      name: '',
      description: '',

      firstName: '',
      lastName: '',
      companyName: '',
      phoneNumber: '',
      ext: '',
      emailAddress: '',
      salesTeamId: '',
      salesFunnelId: '',

      assigneeId: '',
      leadStatus: '',
      nextActionDate: null,

      opportunityStageId: '',
      salesFunnelStageId: '',

      note: '',
    }))
  }

  return (
    <Box>
      <Typography variant="h7">Select Import Type*</Typography>
      <Box ml={2} mb={2} mt={0.8}>
        <FormControl component="fieldset">
          <RadioGroup name="entityType" onChange={onChange} value={entityType}>
            {importTypes.map((type) => (
              <FormControlLabel
                key={type.value}
                disabled={type.disabled}
                value={type.value}
                control={<Radio sx={{ padding: '4px 4px 4px 0' }} />}
                label={type.label}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>
    </Box>
  )
}
